const AUTH_TOKEN_STORAGE_KEY = "token";

const safeStorage = (storageName) => {
  if (typeof window === "undefined") return null;
  return window[storageName] || null;
};

const parseStoredToken = (value) => {
  if (!value) return null;
  try {
    return JSON.parse(value);
  } catch (_error) {
    return null;
  }
};

export const getStoredAuthToken = () => {
  const session = safeStorage("sessionStorage");
  const local = safeStorage("localStorage");

  const sessionToken = parseStoredToken(session?.getItem(AUTH_TOKEN_STORAGE_KEY));
  if (sessionToken) {
    return sessionToken;
  }

  const legacyRawToken = local?.getItem(AUTH_TOKEN_STORAGE_KEY);
  const legacyToken = parseStoredToken(legacyRawToken);
  if (legacyRawToken && legacyToken) {
    if (session) {
      session.setItem(AUTH_TOKEN_STORAGE_KEY, legacyRawToken);
    }
    if (local) {
      local.removeItem(AUTH_TOKEN_STORAGE_KEY);
    }
    return legacyToken;
  }

  return null;
};

export const setStoredAuthToken = (token) => {
  const session = safeStorage("sessionStorage");
  const local = safeStorage("localStorage");
  if (session) {
    session.setItem(AUTH_TOKEN_STORAGE_KEY, JSON.stringify(token));
  }
  if (local) {
    local.removeItem(AUTH_TOKEN_STORAGE_KEY);
  }
};

export const clearStoredAuthToken = () => {
  const session = safeStorage("sessionStorage");
  const local = safeStorage("localStorage");
  if (session) {
    session.removeItem(AUTH_TOKEN_STORAGE_KEY);
  }
  if (local) {
    local.removeItem(AUTH_TOKEN_STORAGE_KEY);
    local.removeItem("authSessionId");
  }
  if (session) {
    session.removeItem("authSessionId");
  }
};
